import API from '../../sunwiseAPI';

const ENTITY = 'customers-energies-consumptions';

export const getConsumptionEnergy = (projectUUID) =>
    API.get(`/api/v2/${ENTITY}/${projectUUID}/public/`);
